export default __webpack_public_path__ + "static/media/email-icon.1e62ec22.svg";